import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /**
   * Label of a step */
  children: PropTypes.string.isRequired,
  labelComplete: PropTypes.string.isRequired,
  labelInitial: PropTypes.string.isRequired,
  /**
   * Value of the selected step
   */
  value: PropTypes.string.isRequired,
  /**
   * sets the step as complete,also sets the aria-label accordingly
   */
  isComplete: PropTypes.bool,
  /**
   * sets the step as active, also sets the aria-current attribute
   */
  isCurrentStep: PropTypes.bool,
  /**
   * if True the step is disabled */
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func
};
function ProgressStep(_ref) {
  var isCurrentStep = _ref.isCurrentStep,
    children = _ref.children,
    labelInitial = _ref.labelInitial,
    labelComplete = _ref.labelComplete,
    isComplete = _ref.isComplete,
    isDisabled = _ref.isDisabled,
    onClick = _ref.onClick,
    value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "progress-step",
    "data-current-step": isCurrentStep,
    "data-testid": "progress-step"
  }, /*#__PURE__*/React__default.createElement("button", {
    "aria-label": isComplete ? labelComplete : labelInitial,
    "aria-current": isCurrentStep ? 'step' : null,
    "aria-disabled": isDisabled ? true : null,
    className: "progress-step-button",
    "data-disabled": isDisabled ? true : null,
    disabled: isDisabled,
    onClick: onClick,
    type: "button",
    value: value
  }, children));
}
ProgressStep.propTypes = propTypes;

export { ProgressStep as default };
//# sourceMappingURL=ProgressStep.js.map
